import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { motion, AnimatePresence } from "framer-motion";
import "swiper/css";

import classes from "./Productos.module.css";

const mupis = [
    "/img/productos/mupi1.png",
    "/img/productos/mupi2.png",
];

const landmarks = [
    "/img/productos/landmark1.png",
    "/img/productos/landmark2.png",
];

const pantallas = [
    "/img/productos/pantalla1.png",
    "/img/productos/pantalla2.png",
    "/img/productos/pantalla3.png",
    "/img/productos/pantalla4.png",
    "/img/productos/pantalla5.png",
    "/img/productos/pantalla6.png",
    "/img/productos/pantalla7.png",
    "/img/productos/pantalla8.png",
    "/img/productos/pantalla9.png"
];

const tiendas = [
    "/img/productos/tienda1.png",
    "/img/productos/tienda2.png",
    "/img/productos/tienda3.jpg",
    "/img/productos/tienda4.jpg"
];

const urbans = [
    "/img/productos/uw1.png",
    "/img/productos/uw2.png"
];

const btls = [
    "/img/productos/btl1.png",
    "/img/productos/btl2.png"
];

const pasarelas = [
    "/img/productos/pasarela1.png",
    "/img/productos/pasarela2.png"
];

const centros = [
    "/img/centros/centraNorte.png",
    "/img/centros/centroCivico.png",
    "/img/centros/dinamia.jpg",
    "/img/centros/escala.jpg",
    "/img/centros/eskala.png",
    "/img/centros/frutal.png",
    "/img/centros/futeca1.png",
    "/img/centros/futeca2.png",
    "/img/centros/gaura.png",
    "/img/centros/noria.png",
    "/img/centros/obelisco.png",
    "/img/centros/quo.png",
    "/img/centros/reformadores.png",
    "/img/centros/tifany.png",
    "/img/centros/vhista.png",
    "/img/centros/videre.png",
    "/img/centros/vilaflor.png"
];

const medios = [
    "/img/productos/Medios/medio1.jpg",
    "/img/productos/Medios/medio2.jpg",
    "/img/productos/Medios/medio3.jpg",
    "/img/productos/Medios/medio4.jpg",
    "/img/productos/Medios/medio5.jpg",
]

const Productos = () => {
    //Mupis
    const [mupiActual, setMupiActual] = useState(0);
    const avanzarMupi = () => {
        setMupiActual((prev) => (prev + 1) % mupis.length);
    };
    const retrocederMupi = () => {
        setMupiActual((prev) => (prev - 1 + mupis.length) % mupis.length);
    };
    const mupi = mupis[mupiActual];
    
    //Landmarks
    const [landActual, setLandActual] = useState(0);
    const avanzarLand = () => {
        setLandActual((prev) => (prev + 1) % landmarks.length);
    };
    const retrocederLand = () => {
        setLandActual((prev) => (prev - 1 + landmarks.length) % landmarks.length);
    };
    const land = landmarks[landActual];

    //Pantallas
    const [pantallaActual, setPantallaActual] = useState(0);
    const avanzarPantalla = () => {
        setPantallaActual((prev) => (prev + 1) % pantallas.length);
    };
    const retrocederPantalla = () => {
        setPantallaActual((prev) => (prev - 1 + pantallas.length) % pantallas.length);
    };
    const pantalla = pantallas[pantallaActual];

    //Tiendas
    const [tiendaActual, setTiendaActual] = useState(0);
    const avanzarTienda = () => {
        setTiendaActual((prev) => (prev + 1) % tiendas.length);
    };
    const retrocederTienda = () => {
        setTiendaActual((prev) => (prev - 1 + tiendas.length) % tiendas.length);
    };
    const tienda = tiendas[tiendaActual];

    //Urban walls
    const [urbanActual, setUrbanActual] = useState(0);
    const avanzarUrban = () => {
        setUrbanActual((prev) => (prev + 1) % urbans.length);
    };
    const retrocederUrban = () => {
        setUrbanActual((prev) => (prev - 1 + urbans.length) % urbans.length);
    };
    const urban = urbans[urbanActual];    

    //Btls
    const [btlActual, setBtlActual] = useState(0);
    const avanzarBtl = () => {
        setBtlActual((prev) => (prev + 1) % btls.length);
    };
    const retrocederBtl = () => {
        setBtlActual((prev) => (prev - 1 + btls.length) % btls.length);
    };
    const btl = btls[btlActual];

    //Pasarelas
    const [pasarelaActual, setPasarelaActual] = useState(0);
    const avanzarPasarela = () => {
        setPasarelaActual((prev) => (prev + 1) % pasarelas.length);
    };
    const retrocederPasarela = () => {
        setPasarelaActual((prev) => (prev - 1 + pasarelas.length) % pasarelas.length);
    };
    const pasarela = pasarelas[pasarelaActual];

  return (
    <section id="productos" className={classes.productos}>
      <div className={classes.overlay}>
        <h2 className={classes.tituloG}>
            <span className={classes.masGrande}>
                Explora
            </span>
            <br></br>
            <div className={classes.tab}>
            nuestro portafolio
            </div>
        </h2>
        {/* Mupis digitales */}
        <div className={classes.section}>
            <div className={classes.gridDosColumnas}>
                <div className={classes.card}>
                    <div className={classes.navegador}>
                        <button onClick={retrocederMupi}>⟵</button>
                            <AnimatePresence mode="wait">
                                <motion.div
                                    key={mupi}
                                    className={classes['beneficio-card-unico']}
                                    initial={{ opacity: 0, y: 30 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -30 }}
                                    transition={{ duration: 0.4 }}
                                >
                                    <img src={mupi} alt={`Mupi imagen`} loading="lazy" className={classes.imagen} />
                                </motion.div>
                            </AnimatePresence>
                        <button onClick={avanzarMupi}>⟶</button>
                    </div>
                </div>
                <div className={classes.cardTitulo}>
                    <h2 className={classes.subtitulo}>Mupis Digitales</h2>
                </div>
            </div>
        </div>
        {/* Landmarks */}
        <div className={classes.section}>
            <div className={classes.gridDosColumnas}>
                <div className={classes.cardTitulo}>
                    <h2 className={classes.subtitulo}>Landmarks</h2>
                </div>
                <div className={classes.card}>
                    <div className={classes.navegador}>
                        <button onClick={retrocederLand}>⟵</button>
                            <AnimatePresence mode="wait">
                                <motion.div
                                    key={land}
                                    className={classes['beneficio-card-unico']}
                                    initial={{ opacity: 0, y: 30 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -30 }}
                                    transition={{ duration: 0.4 }}
                                >
                                    <img src={land} alt={`Landmark imagen`} loading="lazy" className={classes.imagen} />
                                </motion.div>
                            </AnimatePresence>
                        <button onClick={avanzarLand}>⟶</button>
                    </div>
                </div>
            </div>
        </div>
        {/* Pantallas LED */}
        <div className={classes.section}>
            <div className={classes.gridDosColumnas}>
                <div className={classes.card}>
                    <div className={classes.navegador}>
                        <button onClick={retrocederPantalla}>⟵</button>
                            <AnimatePresence mode="wait">
                                <motion.div
                                    key={pantalla}
                                    className={classes['beneficio-card-unico']}
                                    initial={{ opacity: 0, y: 30 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -30 }}
                                    transition={{ duration: 0.4 }}
                                >
                                    <img src={pantalla} alt={`Pantalla imagen`} loading="lazy" className={classes.imagen} />
                                </motion.div>
                            </AnimatePresence>
                        <button onClick={avanzarPantalla}>⟶</button>
                    </div>
                </div>
                <div className={classes.cardTitulo}>
                    <h2 className={classes.subtitulo}>Pantallas Digitales</h2>
                </div>
            </div>
        </div>
        {/* Tiendas */}
        <div className={classes.section}>
            <div className={classes.gridDosColumnas}>
                <div className={classes.cardTitulo}>
                    <h2 className={classes.subtitulo}>Puntos de Venta</h2>
                </div>
                <div className={classes.card}>
                    <div className={classes.navegador}>
                        <button onClick={retrocederTienda}>⟵</button>
                            <AnimatePresence mode="wait">
                                <motion.div
                                    key={tienda}
                                    className={classes['beneficio-card-unico']}
                                    initial={{ opacity: 0, y: 30 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -30 }}
                                    transition={{ duration: 0.4 }}
                                >
                                    <img src={tienda} alt={`Tienda imagen`} loading="lazy" className={classes.imagen} />
                                </motion.div>
                            </AnimatePresence>
                        <button onClick={avanzarTienda}>⟶</button>
                    </div>
                </div>
            </div>
        </div>
        {/* Urban walls */}
        <div className={classes.section}>
            <div className={classes.gridDosColumnas}>
                <div className={classes.card}>
                    <div className={classes.navegador}>
                        <button onClick={retrocederUrban}>⟵</button>
                            <AnimatePresence mode="wait">
                                <motion.div
                                    key={urban}
                                    className={classes['beneficio-card-unico']}
                                    initial={{ opacity: 0, y: 30 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -30 }}
                                    transition={{ duration: 0.4 }}
                                >
                                    <img src={urban} alt={`Urban imagen`} loading="lazy" className={classes.imagen} />
                                </motion.div>
                            </AnimatePresence>
                        <button onClick={avanzarUrban}>⟶</button>
                    </div>
                </div>
                <div className={classes.cardTitulo}>
                    <h2 className={classes.subtitulo}>Urban Walls</h2>
                </div>
            </div>
        </div>
        {/* BTL */}
        <div className={classes.section}>
            <div className={classes.gridDosColumnas}>
                <div className={classes.cardTitulo}>
                    <h2 className={classes.subtitulo}>BTL</h2>
                </div>
                <div className={classes.card}>
                    <div className={classes.navegador}>
                        <button onClick={retrocederBtl}>⟵</button>
                            <AnimatePresence mode="wait">
                                <motion.div
                                    key={btl}
                                    className={classes['beneficio-card-unico']}
                                    initial={{ opacity: 0, y: 30 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -30 }}
                                    transition={{ duration: 0.4 }}
                                >
                                    <img src={btl} alt={`BTL imagen`} loading="lazy" className={classes.imagen} />
                                </motion.div>
                            </AnimatePresence>
                        <button onClick={avanzarBtl}>⟶</button>
                    </div>
                </div>
            </div>
        </div>
        {/* Pasarelas */}
        <div className={classes.section}>
            <div className={classes.gridDosColumnas}>
                <div className={classes.card}>
                    <div className={classes.navegador}>
                        <button onClick={retrocederPasarela}>⟵</button>
                            <AnimatePresence mode="wait">
                                <motion.div
                                    key={pasarela}
                                    className={classes['beneficio-card-unico']}
                                    initial={{ opacity: 0, y: 30 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -30 }}
                                    transition={{ duration: 0.4 }}
                                >
                                    <img src={pasarela} alt={`Pasarela imagen`} loading="lazy" className={classes.imagen} />
                                </motion.div>
                            </AnimatePresence>
                        <button onClick={avanzarPasarela}>⟶</button>
                    </div>
                </div>
                <div className={classes.cardTitulo}>
                    <h2 className={classes.subtitulo}>Pasarelas</h2>
                </div>
            </div>
        </div>
        { /*    Medios */}
        <div className={classes.section}>
            <div className={classes.gridDosColumnas}>
                <div className={classes.cardTitulo}>
                    <div className={classes['container-centrado']}>
                        <h2 className={classes.subtitulo}>Medios</h2>
                        <div className={classes['valor-lista']}>
                            <p>Mupis digitales</p>
                            <p>Standees doble cara</p>
                            <p>Pantallas en sótanos</p>
                            <p>Cajas de luz</p>
                            <p>Story boards</p>
                            <p>Puertas de elevadores</p>
                            <p>Talanqueras</p>
                            <p>Fachadas</p>
                            <p>Vitrinas</p>
                            <p>Exhibiciones</p>
                            <p>Activaciones</p>
                        </div>
                    </div>
                </div>     
                <div className={classes.card}>
                    <div className={classes.gridDosColumnas}>
                        <div className={classes.columnaIzquierda}>
                            <img src={medios[0]} alt={`Medio imagen`} loading="lazy" className={classes.imagenPeque} />
                            <img src={medios[1]} alt={`Medio imagen`} loading="lazy" className={classes.imagenPeque} />
                            <img src={medios[2]} alt={`Medio imagen`} loading="lazy" className={classes.imagenPeque} />
                        </div>
                        <div className={classes.columnaDerecha}>
                            <img src={medios[3]} alt={`Medio imagen`} loading="lazy" className={classes.imagen} />
                            <img src={medios[4]} alt={`Medio imagen`} loading="lazy" className={classes.imagen} />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        { /* Carrusel de clientes */}
        <div className={classes.section}>
            
            <div className={classes.container}>
                <motion.h2 
                    className={classes.titulo}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                >
                    Centros comerciales donde nos encontramos
                </motion.h2>

                <div className={classes['carrusel-envuelto']}>
                        <Swiper
                            modules={[Autoplay]}
                            slidesPerView={3}
                            spaceBetween={50}
                            loop={true}
                            autoplay={{ delay: 1000 }}
                            breakpoints={{
                                640: { slidesPerView: 2 },
                                768: { slidesPerView: 3 },
                                1024: { slidesPerView: 5 },
                            }}
                            >
                            {centros.map((src, index) => (
                                <SwiperSlide key={index}>
                                    <div className={classes['logo-slide']}>
                                        <img src={src} alt={`Centro ${index + 1}`} />
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>    
            </div>
        </div>
    </section>
  );
};

export default Productos;
